import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const CricketIcon = observer('CricketIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.18693 15.3216L5.35653 14.4912L3.17416 16.6736C-1.31812 7.92356 7.91681 -1.31929 16.6732 3.17444L14.4909 5.35681L15.3213 6.18721L17.7034 3.80512C18.0247 4.02974 18.3341 4.27471 18.6306 4.53879L4.5385 18.6308C4.27443 18.3344 4.02949 18.025 3.80483 17.7036L6.18693 15.3216ZM14.491 7.01757L13.6606 6.18717L12.415 7.43279L13.2454 8.26318L14.491 7.01757ZM12.4149 9.09358L11.5845 8.26318L10.339 9.50876L11.1693 10.3392L12.4149 9.09358ZM10.3389 11.1696L9.50852 10.3392L8.26294 11.5848L9.09334 12.4152L10.3389 11.1696ZM8.26294 13.2456L7.43254 12.4152L6.18693 13.6608L7.01732 14.4912L8.26294 13.2456Z'
                fill='fill'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.8126 8.67837L18.643 9.50877L20.8254 7.32636C25.3177 16.0764 16.0827 25.3192 7.32621 20.8255L9.50858 18.6431L8.67819 17.8127L6.29609 20.1948C5.97478 19.9702 5.66534 19.7252 5.36893 19.4612L19.461 5.36911C19.7251 5.66556 19.97 5.97497 20.1947 6.29631L17.8126 8.67837ZM9.5085 16.9824L10.3389 17.8128L11.5845 16.5672L10.7541 15.7368L9.5085 16.9824ZM11.5845 14.9064L12.4149 15.7368L13.6605 14.4912L12.8301 13.6608L11.5845 14.9064ZM13.6605 12.8304L14.4909 13.6608L15.7365 12.4152L14.9061 11.5848L13.6605 12.8304ZM15.7366 10.7543L16.567 11.5847L17.8126 10.3392L16.9822 9.50877L15.7366 10.7543Z'
                fill='fill'
            />
        </SvgElement>
    );
});
